// Selectors
import {createSelector} from '@reduxjs/toolkit';

import {ApplicationState} from '../..';

export const globalStateSelector = (state: ApplicationState) => state

export const globalStateLoadingSelector = createSelector(globalStateSelector, (state) => state.globalState.isLoading || state.authentication.loading);
